
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import PropTypes from "prop-types";
import FavoritesMixin from "../../../../dev/mixins/favoritesMixin";
import { UpperScreen } from '../../../actions/terminal';
import Zergling from '../../../helpers/zergling';
import Config from '../../../../dev/config/conf';
import { UIMixin } from "../../../mixins/uiMixin";
import { OpenPopup } from "../../../actions/ui";
import { broadcast, broadcastChannels } from "../../../helpers/broadcast";
import Helpers from "../../../helpers/helperFunctions";

class StandartGame extends Component {
    async upperScreenStreem (game) {
        const response = await Zergling.get({ video_id: game.video_id, provider: game.tv_type }, 'video_url');
        if (response) {
            Helpers.isSplitScreenAvailable()
                ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                    detail: { command: 'Video', id: game.id, url: response, providerId: game.tv_type } }
                )) : this.props.dispatch(UpperScreen({
                    type: "Video",
                    id: game.id,
                    videoURL: response,
                    tv_type: game.tv_type
                }));
        }
    }

    upperScreenStatistics () {
        const isDualscreen = sessionStorage.getItem("dualscreen") || "false";
        const { game } = this.props;

        if (!game) return;

        if (Helpers.isSplitScreenAvailable()) {
            broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                detail: { command: 'Statistics', id: game.id, url: "", providerId: 0 }
            }));
        } else if (isDualscreen === "true") {
            this.props.dispatch(UpperScreen({
                type: "Statistics",
                id: game.id,
                videoURL: "",
                tv_type: 0
            }));
        } else if (Config.urlForDualScreenStatistics) {
            const envLang = Config.env.lang,
                defaulUrlTakenFromConfig = Config.urlForDualScreenStatistics + Config.main.availableLanguages[envLang].short.toLowerCase(),
                urlHardCodePart = defaulUrlTakenFromConfig + "/external/page/h2h/",
                url = urlHardCodePart + game.team1_id + "/" + game.team2_id;

            this.props.dispatch(OpenPopup("statisticsPopup", {url}));
        }
    }
    openBetBuilder() {
        const { game } = this.props;
        if (!game) return

        game.sportcast_id && this.props.dispatch(OpenPopup('betBuilder', { title: `${game.team1_name} vs ${game.team2_name}`, sportcastId: game.sportcast_id}));
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

StandartGame.propTypes = {
    selectorKey: PropTypes.string,
    gameId: PropTypes.number,
    gameType: PropTypes.string,
    sportAlias: PropTypes.string
};

const mapStateToProps = (_, ownParams) => {
    let {selectorKey, gameId} = ownParams;
    return createSelector(
        [
            state => state.standartGameList[selectorKey] && JSON.stringify(state.standartGameList[selectorKey][gameId]),
            state => state.standartGameList[ownParams.selectorKey][ownParams.gameId] && JSON.stringify(state.standartGameList[ownParams.selectorKey][ownParams.gameId]),
            state => state.favorites.game[gameId] && gameId,
            state => state.terminal.boostedOddsGameIds
        ],
        (game, favoritesGameId, data, boostedOddsGameIds) => {
            return {
                game: game && JSON.parse(game),
                favoritesGameId,
                stat: data && JSON.parse(data),
                boostedOddsGameIds
            };
        });
};

export default connect(mapStateToProps)(FavoritesMixin({Component: UIMixin({Component: StandartGame})}))